import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'cleanHtml',
    standalone: false
})
export class CleanHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(htmlContent) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }
}
